<div
  class="brand-plp-actions"
  fxFlex="100"
  fxLayout="row"
  fxLayoutGap.mm-mobile="14px grid"
  fxLayout.mm-mobile="row wrap"
  fxLayoutAlign.mm-mobile="start"
>
  <app-search-sort-toggler class="brand-plp-actions__sort-toggler" [class.sticky]="isSticky"> </app-search-sort-toggler>

  <div class="brand-plp-actions__filters">
    <button
      [class.sticky]="isSticky"
      class="brand-plp-actions__filter-btn"
      mm-button
      [ngClass]="{'zero-count' : (filtersCount$ | async) === 0}"
      color="secondary"
      iconButton="true"
      (click)="onOpenFilters()"
      [mmTestTarget]="'toogle-filter-button'"
    >
      <mm-icon name="filter"></mm-icon>
      {{ 'CATALOG.CATALOG_PAGE.CATALOG_TOOLBAR.FILTERS_BUTTON.TEXT' | translate }}
    </button>
    <ng-container *ngIf="filtersCount$ | async as filtersCount">
      <div class="brand-plp-actions__filter-btn-count">
        {{ filtersCount$ | async }}
      </div>
    </ng-container>
  </div>
</div>
